import { useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate5';

import {
  type CancelPaymentParams,
  type CancelPaymentResponse,
} from '@sg/shared-fe/features/ordering';

import {
  GiftCardCancelPaymentDocument,
  type GiftCardCancelPaymentMutation,
} from '../../graphql/GiftCardCancelPayment.generated';

export const useGiftCardCancelPayment = () => {
  const client = useClient();

  const cancelGiftCardPayment = useMemo(
    () =>
      fromPromise<CancelPaymentResponse, CancelPaymentParams>(async ({ input }) => {
        const { paymentIntentId } = input;
        const mutation = client.mutation<GiftCardCancelPaymentMutation>;

        if (!paymentIntentId) throw new Error('Payment intent ID is required');

        const response = await mutation(GiftCardCancelPaymentDocument, {
          input: { paymentIntentId },
        }).toPromise();

        const maybeData = response.data?.cancelOrderPaymentIntent;

        return {
          success: Boolean(maybeData?.success),
        };
      }),
    [client.mutation],
  );

  return { cancelGiftCardPayment };
};
